// extracted by mini-css-extract-plugin
module.exports = {"container":"List_container__2BZuY","default":"List_default__oWEx5","personalTab":"List_personalTab__389HP","bulk":"List_bulk__C44_e","description":"List_description__xWHBO"};